import React from 'react';
import PropTypes from 'prop-types';


function MobileRsvpIntro({ events, selector, noPlusOne, onePlusOne, handleNextStep }) { // eslint-disable-line
  return (
    <div>
      <div className="entity-section">
        <div className="guests-invited">
          <h4>Name{noPlusOne ? '' : 's'}</h4>
          {noPlusOne ? (
            <p>{selector('guests') && selector('guests')[0] && selector('guests')[0].first_name}</p>
          ) : (
            <p>{selector('guests') && selector('guests')[0] && selector('guests')[0].first_name} &amp; {selector('guests') && selector('guests').length - 1} Guest{onePlusOne ? '' : 's'}</p>
          )}
        </div>
        <div className="event-invites">
          <h4>You are invited to</h4>
          <div className="event-invite-list">
            {events && events.length > 0 && events.map(event => (
              <p key={event.id}>{event.name}</p>
            ))}
          </div>
        </div>
        <div className="btn btn-primary btn-wide" onClick={() => handleNextStep(0)}>RSVP</div>
      </div>
    </div>
  );
}

MobileRsvpIntro.propTypes = {
  events: PropTypes.arrayOf(PropTypes.shape({})),
  selector: PropTypes.func.isRequired,
  noPlusOne: PropTypes.bool,
  onePlusOne: PropTypes.bool,
  handleNextStep: PropTypes.func,
};

export default MobileRsvpIntro;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/MultiPageRsvpIntro.jsx